import React from 'react';
import EmptyPage from '../EmptyPage';

const UrgentPage: React.FC = () => {
  return (
    <EmptyPage
      title="긴급"
      icon="AlertTriangle"
      description="긴급한 작업과 알림을 관리합니다."
      parentTitle="대시보드"
    />
  );
};

export default UrgentPage;
